<template>
  <div class="all">
    <div class="content" ref="printMe" v-if="!output">
      <div class="title">
        <img class="logo" src="/oss/logos/aiYouth.png"/>
        <!-- <div class="medal"> -->
        <img :src="medal" class="medal" />
        <!-- </div> -->
      </div>
      <div class="body">
        <div class="user">
          <div class="text">{{userInfo}}</div>
          <div class="small">的战绩</div>
        </div>
        <div class="rank" v-if="rank.prov">
          <div class="small">超过全国{{group}}百分比</div>
          <div class="percentage">
            <div>{{rank.percentage}}%</div>
          </div>

          <div class="area">
            <div class="value" v-if="rank.prov!='-'">第 <b>{{rank.prov}}</b> 名</div>
            <div class="value" v-else>尚无排名</div>
            <div class="key">{{area.replace('赛区', '战区')}}排名</div>
          </div>

          <div class="area">
            <div class="value" v-if="rank.national!='-'">第 <b>{{rank.national}}</b> 名</div>
            <div class="value" v-else>尚无排名</div>
            <div class="key">全国战区排名</div>
          </div>

          <div class="area">
            <div class="value"><b>{{(rank.duration/60).toFixed(1)}}</b></div>
            <div class="key">累积挑战分钟数</div>
          </div>

          <div class="area">
            <div class="value"><b>{{rank.score}}</b></div>
            <div class="key">战绩积分</div>
          </div>
          <div class="time">
            {{dateTime}}
          </div>
        </div>
        <div class="rank noitem" v-else>
          暂无数据
        </div>
      </div>
      <div class="bottom">
        <img alt="" :src="qrcode" class="qr" />
        <div class="desc">
          AI算法挑战活动是零基础，零报名费，边赛边学的全球公益编程活动，网址：aishiqingsai.org.cn，{{endDate}}初赛截止，等你来战！
          <br>
          识别二维码学习硅谷原版编程课
        </div>
      </div>
    </div>
    <div class="mb" v-if="!output || !showShare" @click="dismiss">
      <div>
        <div v-for="m in message">{{m}}</div>
      </div>
    </div>
    <div class="final">
      <img :src="output" class="img">
    </div>
  </div>
</template>

<script>
 import Logo from '@/components/Logo.vue'
 import MyButton from '@/components/Button.vue'
 import MyImage from '@/components/Image.vue'
 import rankPng from '@/assets/image/share/rank.png'
 import qrPng from '@/assets/image/share/qr.png'
 import fingerPng from '@/assets/image/share/finger.png'

 export default {
   name: 'Share',
   computed: {
     rankPng() {
       return rankPng
     },
    endDate() {
       if(new Date().getMonth < 7) {
         return '5月30日'
       } else {
         return '11月30日'
       }
     },
     dateTime() {
       let y = new Date().getFullYear()
       let m = new Date().getMonth() +1
       let d = new Date().getDate();
       let time = new Date().getHours();
       let ttext = '00:00';
       if (time >= 12)
       {
         ttext = '12:00';
       }
       if (time >= 20)
       {
         ttext = '20:00';
       }

       return y + '-' + m + '-' + d + ' '+ ttext + ' 更新'
     },
     imgcoco() {
       /* return 'https://coco-assets.oss-cn-beijing.aliyuncs.com/aiyouth/images/bottombar/coco-qr.png'*/
       return qrPng
     },
     imgfinger() {
       return fingerPng
     },
     medal () {
       return '/oss/images/share/timerank-' +
              this.level+
              '.png';
     },
     level () {
       let time = this.rank.duration;
       if(time < 5000)
         return 1;
       else if(time < 10000)
         return 2;
       else if(time < 20000)
         return 3;
       else if(time < 50000)
         return 4;
       else if(time < 100000)
         return 5;
       else if(time < 150000)
         return 6;
       else if(time < 220000)
         return 7;
       else if(time < 280000)
         return 8;
       else
         return 9;
     },
     qrcode() {
       return '/oss/images/share/shareQR.png';
     },
     avatar() {
       let index = (this.id % 16) | 0
       return require('@/assets/image/avatar/' + index + '.png')
     },
     user() {
       return this.$store.state.auth.user
     },
     userInfo() {
       return this.user.name
     },
     aiyouth() {
       return this.$store.state.logo.mainBlack
     },
     logoStyle() {
       return {
         'height': '60px'
       }
     },
     buttonStyle() {
       return {
         'border-radius': '5px',
         'font-size': '16px',
         'display': 'flex',
         'align-items': 'center',
         'justify-content': 'center',
         'width': '5.5em',
         'height': '24px'
       }
     }
   },
   data() {
     return {
       rank: {
         prov: 0,
         national: 5,
         score: 0,
         duration: 0,
         percentage: 0
       },
       message: ['生成分享海报中，请稍候...'],
       area: '上海',
       date: '',
       id: 0,
       group: '',
       username: '',
       output: false,
       showShare: false,
     }
   },
   methods: {
     dismiss() {
       if (!this.output) return;
       this.showShare = true;
     },
     async print() {
       this.showShare = false
       this.message =['生成成功', '长按分享图片']
       const el = this.$refs.printMe
       const options = {
         type: 'dataURL',
         scale: 1
       }
       this.output = await this.$html2canvas(el, options)
     }
   },
   mounted() {
     this.$http.post('/api/rank/share')
         .then(uuid=>{
           this.$http.get('/api/rank/share/'+ uuid.data)
               .then(res => {
                 this.area = res.data.province_name
                 this.rank.percentage = res.data.percentage.toFixed(0)
                 this.rank.prov = res.data.province_rank == -1 ? '-' : res.data.province_rank
                 this.rank.national = res.data.national_rank == -1 ? '-' : res.data.national_rank
                 this.rank.duration = res.data.duration
                 this.rank.score = res.data.score
                 this.id = res.data.id
                 this.username = res.data.username
                 this.group = res.data.group
                 this.date = res.data.date
                 document.title = this.username + '的AI算法挑战活动战绩|' + res.data.date
                 this.print()
               })
           
         })
         .catch(e => {
           this.message = ['您还没有竞技场分数, 请返回']
         })
   },
   components: {
     logo: Logo,
     my_button: MyButton,
     my_image: MyImage
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .all{
   margin:0;
   padding: 0;
   display: flex;
   align-items: center;
   justify-content:center;
 }

 .title, .body{
   color: white;
   box-sizing: border-box;
 }

 .title{
   border-radius: 5px;
   position: relative;
   width: 1117px;
   height: 160px;
   margin-top: 10px;
   margin-bottom: 120px;
 }

 .body{
   width: 1117px;
   height: 1797px;
   text-align: center;
 }

 .content{
   background: url(/oss/images/share/myscore-bg.png);
   background-size: 1117px 2197px;
   position: relative;
   width: 1117px;
   height: 2197px;
 }

 .user{
   font-size: 60px;
   margin-top: 80px;
   text-align: center;
 }

 .small{
   font-size:32px;
 }

 .rank{
   margin-top: 350px;
   height: 1200px;
 }

 .rank .percentage{
   font-size: 180px;
   font-style: italic;
   margin-bottom: 40px;
 }

 .area{
   display: flex;
   color: rgb(160, 196, 217);
   width: 800px;
   align-items: center;
   margin: auto;
   margin-top: 80px;
   justify-content: space-between;
 }
 .area .value{
   white-space: pre;
   font-size: 64px;
   justify-content:flex-end;
 }
 .area .key{
   font-size: 44px;
 }
 .area .value, .area .key{
   flex-basis: 340px;
   display: flex;
   align-items: flex-end;
 }
 .bottom {
   color: white;
   width: 1110px;
   position: absolute;
   bottom: 5px;
   left: 5px;
 }
 .bottom .qr{
   position: absolute;
   bottom: 0;
   width: 180px;
 }
 .desc{
   margin-left: 190px;
   font-size: 28px;
   margin-bottom: 25px;
 }
 .logo{
   width: 300px;
   position: absolute;
   left: 10px;
 }
 .medal {
   width: 300px;
   position: absolute;
   right: 5px;
 }


 .mb{
   width: 100vw;
   height: 100vh;
   background-color: rgba(10, 10, 10, 0.8);
   position: fixed;
   top: 0;
   display: flex;
   justify-content: center;
   left: 0;
 }

 .mb > div{
   position: absolute;
   top: 5em;
   font-size: 6vw;
   color: white;
   display: flex;
   flex-direction:column;
   align-items:center;
 }

 .img{
   max-width: 100vw;
   max-height: 100vh;
 }

 .board{
   display: flex;
   flex-direction: row;
   align-items: center;
 }
 .time{
   padding-top: 160px;
   font-size: 30px;
 }
 .board > div{
   margin-left: 10px;
 }
 .noitem{
   line-height: 5em;
   margin-bottom: 62vh;
 }
 .final{
   display: flex;
   align-items:center;
   justify-content: center;
   height: 100vh;
   width: 100vw;
 }
 .final .img{
   width: auto;
   max-height: 100vh;
   max-width: 100vw;
 }
</style>
